import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, MessageCircle, MapPin } from 'lucide-react';
import axios from 'axios';
import Logo from './Logo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/`).then(res => setSettings(res.data)).catch(() => {});
  }, []);

  const addr = settings?.address || 'Jl Abu Bakar Gg.Azzubair I No.5 Glondong RT.04 Wirokerten Banguntapan Bantul Yogyakarta';
  const phone1 = settings?.contact_phone_1 || '085-7000-40403';
  const phone2 = settings?.contact_phone_2 || '085-7433-50085';
  const phone1Clean = phone1.replace(/[^0-9]/g, '');
  const phone2Clean = phone2.replace(/[^0-9]/g, '');

  return (
    <footer className="bg-card border-t border-border mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Logo size="md" className="mb-4" />
            <p className="text-muted-foreground text-sm leading-relaxed">
              Platform pemesanan paket Umrah terpercaya dengan layanan terbaik untuk perjalanan ibadah Anda.
            </p>
            <div className="flex space-x-4 mt-4">
              <a href={`https://instagram.com/${settings?.instagram || 'layanan_umrah'}`} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg font-['Outfit'] mb-4">Tautan Cepat</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-muted-foreground hover:text-primary transition-colors text-sm">Beranda</Link></li>
              <li><Link to="/pilih-umrah" className="text-muted-foreground hover:text-primary transition-colors text-sm">Paket Umrah</Link></li>
              <li><Link to="/about" className="text-muted-foreground hover:text-primary transition-colors text-sm">Tentang Kami</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors text-sm">Hubungi Kami</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg font-['Outfit'] mb-4">Layanan</h3>
            <ul className="space-y-2">
              <li><Link to="/pilih-umrah" className="text-muted-foreground hover:text-primary transition-colors text-sm">Paket Umrah</Link></li>
              <li><Link to="/packages?type=haji" className="text-muted-foreground hover:text-primary transition-colors text-sm">Paket Haji</Link></li>
              <li><Link to="/umrah-mandiri" className="text-muted-foreground hover:text-primary transition-colors text-sm">Umrah Mandiri</Link></li>
              <li><Link to="/umrah-selection" className="text-muted-foreground hover:text-primary transition-colors text-sm">Visa & Dokumen</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg font-['Outfit'] mb-4">Hubungi Kami</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground text-sm">{addr}</span>
              </li>
              <li className="flex items-center space-x-2">
                <a href={`https://wa.me/62${phone1Clean}`} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-muted-foreground hover:text-primary transition-colors">
                  <MessageCircle className="h-5 w-5 text-primary flex-shrink-0" />
                  <span className="text-sm">{phone1}</span>
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <a href={`https://wa.me/62${phone2Clean}`} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-muted-foreground hover:text-primary transition-colors">
                  <MessageCircle className="h-5 w-5 text-primary flex-shrink-0" />
                  <span className="text-sm">{phone2}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} {settings?.site_name || 'layanan.umroh'}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
